const state = () => ({
  selectedDefinitions: [],
})

const getters = {
  selectedDefinitions: (state) => {
    return state.selectedDefinitions
  },
}

const actions = {}

const mutations = {
  setSelectedDefinitions(state, selectedProductDefinitions) {
    state.selectedDefinitions = selectedProductDefinitions
  },
  addSelectedDefinition(state, selectedProductDefinitions) {
    state.selectedDefinitions.push(selectedProductDefinitions)
  },
  removeSelectedDefinition(state, index) {
    state.selectedDefinitions.splice(index, 1)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
